import { Suspense, useEffect } from "react";

import { useCustomerServiceApi } from "@/api/hooks/customerService.hook";
import { AddressValidationProvider } from "@/components/Address/AddressValidation/context/addressValidation.context";
import { useThunkDispatch } from "@/redux/dispatcher";
import { load as getVatPrefixes } from "@/redux/modules/api/data/vatPrefixes/vatPrefixes.module";
import {
    broadcastMessage,
    clearMessageById
} from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import BusinessGiftCardRequest from "./businessGiftCardRequest.component";
import { RequestBusinessGiftCardRequest } from "./businessGiftCardRequest.types";

const BusinessGiftCardRequestContainer = () => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();

    const [{ loading: isSubmitting }, requestBusinessGiftCard] =
        useCustomerServiceApi<RequestBusinessGiftCardRequest>(
            {
                url: "/giftcard/business",
                method: "POST"
            },
            { manual: true, useCache: false }
        );

    useEffect(() => {
        dispatch(getVatPrefixes());
    });

    const onSubmit = (
        request: RequestBusinessGiftCardRequest
    ): Promise<void> => {
        clearMessageById("business-giftcard-request-success");
        return new Promise((resolve, reject) => {
            return requestBusinessGiftCard({ data: request })
                .then(() => {
                    broadcastMessage({
                        id: "business-giftcard-request-success",
                        text: t("business.giftcard.request.success.message"),
                        status: "success",
                        dismissible: true,
                        activeScroll: true
                    });
                    resolve();
                })
                .catch(() => {
                    broadcastMessage({
                        id: "business-giftcard-request-failure",
                        text: t("business.giftcard.request.failure.message"),
                        status: "danger",
                        dismissible: true,
                        activeScroll: true
                    });
                    reject();
                });
        });
    };

    return (
        <Suspense fallback={<p>{t("common.loading")}</p>}>
            <AddressValidationProvider>
                <BusinessGiftCardRequest
                    onSubmit={onSubmit}
                    isLoading={isSubmitting}
                />
            </AddressValidationProvider>
        </Suspense>
    );
};

export { BusinessGiftCardRequestContainer };
